/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIManualShareJSONRequest } from './APIManualShareJSONRequest';
import {
    APIManualShareJSONRequestFromJSON,
    APIManualShareJSONRequestFromJSONTyped,
    APIManualShareJSONRequestToJSON,
} from './APIManualShareJSONRequest';
import type { APIAutomaticShareJsonRequest } from './APIAutomaticShareJsonRequest';
import {
    APIAutomaticShareJsonRequestFromJSON,
    APIAutomaticShareJsonRequestFromJSONTyped,
    APIAutomaticShareJsonRequestToJSON,
} from './APIAutomaticShareJsonRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISharepointCreationRequest
 */
export interface APISharepointCreationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof APISharepointCreationRequest
     */
    isBomShare?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreationRequest
     */
    feedbackForm?: string;
    /**
     * 
     * @type {number}
     * @memberof APISharepointCreationRequest
     */
    shareDuration: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APISharepointCreationRequest
     */
    articles: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreationRequest
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APISharepointCreationRequest
     */
    request?: string | null;
    /**
     * 
     * @type {Array<APIAutomaticShareJsonRequest>}
     * @memberof APISharepointCreationRequest
     */
    automaticShares?: Array<APIAutomaticShareJsonRequest>;
    /**
     * 
     * @type {Array<APIManualShareJSONRequest>}
     * @memberof APISharepointCreationRequest
     */
    manualShares?: Array<APIManualShareJSONRequest>;
}

/**
 * Check if a given object implements the APISharepointCreationRequest interface.
 */
export function instanceOfAPISharepointCreationRequest(value: object): value is APISharepointCreationRequest {
    if (!('shareDuration' in value) || value['shareDuration'] === undefined) return false;
    if (!('articles' in value) || value['articles'] === undefined) return false;
    return true;
}

export function APISharepointCreationRequestFromJSON(json: any): APISharepointCreationRequest {
    return APISharepointCreationRequestFromJSONTyped(json, false);
}

export function APISharepointCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISharepointCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isBomShare': json['is_bom_share'] == null ? undefined : json['is_bom_share'],
        'feedbackForm': json['feedback_form'] == null ? undefined : json['feedback_form'],
        'shareDuration': json['share_duration'],
        'articles': json['articles'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'request': json['request'] == null ? undefined : json['request'],
        'automaticShares': json['automatic_shares'] == null ? undefined : ((json['automatic_shares'] as Array<any>).map(APIAutomaticShareJsonRequestFromJSON)),
        'manualShares': json['manual_shares'] == null ? undefined : ((json['manual_shares'] as Array<any>).map(APIManualShareJSONRequestFromJSON)),
    };
}

export function APISharepointCreationRequestToJSON(value?: APISharepointCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_bom_share': value['isBomShare'],
        'feedback_form': value['feedbackForm'],
        'share_duration': value['shareDuration'],
        'articles': value['articles'],
        'guest_request': value['guestRequest'],
        'request': value['request'],
        'automatic_shares': value['automaticShares'] == null ? undefined : ((value['automaticShares'] as Array<any>).map(APIAutomaticShareJsonRequestToJSON)),
        'manual_shares': value['manualShares'] == null ? undefined : ((value['manualShares'] as Array<any>).map(APIManualShareJSONRequestToJSON)),
    };
}

